
import { HttpErrorResponse, HttpInterceptorFn } from '@angular/common/http';
import { catchError } from 'rxjs/operators';
import { throwError } from 'rxjs';
import { inject } from '@angular/core';
import { MessageService } from 'primeng/api';

export const errorInterceptorFn: HttpInterceptorFn = (req, next) => {
  const messageService = inject(MessageService);

  return next(req).pipe(
    catchError((error: HttpErrorResponse) => {
      if (error.status === 0) {
        console.error('Erreur de connexion :', error.message);
      } else {
        console.error(`Erreur du serveur ${error.status} :`, error.error);
        switch (error.status) {
          case 404:
            console.log("Ressource non trouvée.")
            break;
          case 403:
            console.log("Accès non autorisé")
            break;
          default:
            console.error(`Erreur du serveur ${error.status} :`, error.error);
        }
      }
      return throwError(() => error);
    })
  );
};